module.exports = __webpack_public_path__ + "fonts/600-normal-cyrillic-ext.3cc614a.woff2";